import { SortCode } from '@dgx-pr-spa/shared/util';
import { CurrentPlan } from '@dgx-pr-spa/shared/util';
import { DirectDebitValidationRequest } from '@dgx-pr-spa/shared/util';
export class DirectDebitHelper {
  constructor(
    public currentPlan?: CurrentPlan,
    public sortCode?: SortCode,
    public accountNumber?: string
  ) {}

  get requestBody(): DirectDebitValidationRequest {
    return {
      request_source: 'BVUK',
      channel_code: '0035',
      channel_group_code: '0005',

      client_code: this.currentPlan.client_code,
      client_group_code: this.currentPlan.client_group_code,

      branchCode: `${this.sortCode.sort1}${this.sortCode.sort2}${this.sortCode.sort3}`,
      accountNumber: this.accountNumber,
    };
  }
}
